(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etres-collection-intro"] && !Shopify.designMode) return;
  try {
    
  function initCollectionFamilies(root = document) {
    root.querySelectorAll('.ec-families-wrap').forEach((wrap) => {
      const nav = wrap.querySelector('.ec-families');
      if (!nav || nav.dataset.scrollHintReady) return;
      nav.dataset.scrollHintReady = 'true';
      const update = () => {
        wrap.classList.toggle('ec-families-wrap--can-scroll', nav.scrollWidth > nav.clientWidth + 2);
        wrap.classList.toggle('ec-families-wrap--at-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2);
      };
      nav.addEventListener('scroll', update, { passive: true });
      nav.addEventListener('wheel', (event) => {
        if (!wrap.classList.contains('ec-families-wrap--can-scroll') || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
        const next = Math.max(0, Math.min(nav.scrollWidth - nav.clientWidth, nav.scrollLeft + event.deltaY));
        if (next !== nav.scrollLeft) {
          nav.scrollLeft = next;
          event.preventDefault();
        }
      }, { passive: false });
      let drag = null;
      let suppressClick = false;
      nav.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !wrap.classList.contains('ec-families-wrap--can-scroll')) return;
        drag = { id: event.pointerId, x: event.clientX, scroll: nav.scrollLeft, moved: false };
      });
      nav.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) > 5) {
          drag.moved = true;
          nav.setPointerCapture(event.pointerId);
          wrap.classList.add('ec-families-wrap--dragging');
        }
        if (drag.moved) {
          nav.scrollLeft = drag.scroll - distance;
          event.preventDefault();
        }
      });
      nav.addEventListener('pointerup', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        suppressClick = drag.moved;
        drag = null;
        wrap.classList.remove('ec-families-wrap--dragging');
        setTimeout(() => { suppressClick = false; }, 0);
      });
      nav.addEventListener('pointercancel', () => {
        drag = null;
        wrap.classList.remove('ec-families-wrap--dragging');
      });
      nav.addEventListener('click', (event) => {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      nav.addEventListener('dragstart', (event) => event.preventDefault());
      new ResizeObserver(update).observe(nav);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionFamilies());
  } else {
    initCollectionFamilies();
  }
  document.addEventListener('shopify:section:load', (event) => initCollectionFamilies(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etres-home-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('etres-comparison')){customElements.define('etres-comparison',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const data=JSON.parse(this.querySelector('[data-model-data]')?.textContent||'[]');const buttons=[...this.querySelectorAll('[data-model]')];const name=this.querySelector('[data-selected-name]');const link=this.querySelector('[data-selected-link]');buttons.forEach((button)=>button.addEventListener('click',()=>{const index=Number(button.dataset.model);buttons.forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});this.querySelectorAll('[data-value-model]').forEach((value)=>value.classList.toggle('is-active',Number(value.dataset.valueModel)===index));if(data[index]){name.textContent=data[index].name;link.href=data[index].url}}))}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etres-home-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('etres-home-discovery')) {
  customElements.define('etres-home-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-tab-index]');
        if (tab) {
          const index = tab.dataset.tabIndex;
          this.querySelectorAll('[role="tab"]').forEach((item) => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.classList.toggle('is-active', active);
          });
          this.querySelectorAll('[data-panel-index]').forEach((panel) => {
            panel.hidden = panel.dataset.panelIndex !== index;
          });
          this.updateProgress();
          return;
        }
        const arrow = event.target.closest('[data-scroll]');
        if (arrow) {
          const rail = this.querySelector('[data-panel-index]:not([hidden]) [data-rail]');
          if (rail) rail.scrollBy({ left: Number(arrow.dataset.scroll) * rail.clientWidth * 0.84, behavior: 'smooth' });
        }
      });
      this.querySelectorAll('[data-rail]').forEach((rail) => rail.addEventListener('scroll', () => this.updateProgress(), { passive: true }));
      this.addEventListener('keydown', (event) => {
        if (!event.target.matches('[role="tab"]') || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const current = tabs.indexOf(event.target);
        const next = tabs[(current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        next.click();
      });
      this.updateProgress();
    }
    updateProgress() {
      const rail = this.querySelector('[data-panel-index]:not([hidden]) [data-rail]');
      const bar = this.querySelector('.etres-discovery__progress span');
      if (!rail || !bar) return;
      const max = rail.scrollWidth - rail.clientWidth;
      bar.style.transform = `scaleX(${max > 0 ? rail.scrollLeft / max : 1})`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etres-home-icons"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('etres-icons')){customElements.define('etres-icons',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const viewport=this.querySelector('[data-icons-viewport]');const prev=this.querySelector('[data-icons-prev]');const next=this.querySelector('[data-icons-next]');const progress=this.querySelector('[data-icons-progress]');if(!viewport)return;const update=()=>{const max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);const share=viewport.clientWidth/Math.max(viewport.scrollWidth,1);const width=Math.min(100,Math.max(12,share*100));progress.style.width=`${width}%`;progress.style.transform=`translateX(${max?viewport.scrollLeft/max*(100/share-100):0}%)`;prev.disabled=viewport.scrollLeft<3;next.disabled=viewport.scrollLeft>max-3};const step=()=>Math.min(viewport.clientWidth*.8,420);prev.addEventListener('click',()=>viewport.scrollBy({left:-step(),behavior:'smooth'}));next.addEventListener('click',()=>viewport.scrollBy({left:step(),behavior:'smooth'}));viewport.addEventListener('scroll',update,{passive:true});let down=false,startX=0,startScroll=0,dragged=false;viewport.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;down=true;dragged=false;startX=event.clientX;startScroll=viewport.scrollLeft});viewport.addEventListener('pointermove',event=>{if(!down)return;const delta=event.clientX-startX;if(Math.abs(delta)>5){dragged=true;viewport.classList.add('is-dragging');viewport.scrollLeft=startScroll-delta}});window.addEventListener('pointerup',()=>{down=false;viewport.classList.remove('is-dragging');setTimeout(()=>{dragged=false},0)});viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation()}},true);update();new ResizeObserver(update).observe(viewport)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etres-home-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('etres-story')){customElements.define('etres-story',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const buttons=[...this.querySelectorAll('[data-story-button]')];const details=[...this.querySelectorAll('[data-story-detail]')];const visuals=[...this.querySelectorAll('[data-story-visual]')];const activate=index=>{buttons.forEach((item,i)=>item.setAttribute('aria-expanded',String(i===index)));details.forEach((item,i)=>item.hidden=i!==index);visuals.forEach((item,i)=>item.hidden=i!==index);const background=buttons[index]?.dataset.storyBackground;if(background)this.style.setProperty('--es-active-panel-bg',background);else this.style.removeProperty('--es-active-panel-bg')};buttons.forEach((button,index)=>button.addEventListener('click',()=>activate(index)));if(buttons.length){const active=buttons.findIndex(button=>button.getAttribute('aria-expanded')==='true');activate(active<0?0:active)}}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
